import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("altius_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("altius_cart", JSON.stringify(items));
  }, [items]);

  const defaultColor = (product) =>
    product.colors && product.colors.length > 0 ? product.colors[0].name : null;

  const add = (product, qty = 1, color = null) =>
    setItems((prev) => {
      const resolved = color || defaultColor(product);
      const colorEntry = (product.colors || []).find((c) => c.name === resolved);
      const variantId = (colorEntry && colorEntry.variant_id) || product.shopify_variant_id || null;
      const key = product.id + (resolved ? `::${resolved}` : "");
      const ex = prev.find((i) => i.id + (i.color ? `::${i.color}` : "") === key);
      if (ex) return prev.map((i) => (i.id + (i.color ? `::${i.color}` : "") === key ? { ...i, qty: i.qty + qty } : i));
      return [...prev, { ...product, qty, color: resolved, variant_id: variantId }];
    });

  const remove = (id, color = null) =>
    setItems((prev) => prev.filter((i) => !(i.id === id && (i.color || null) === color)));

  const setQty = (id, color, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => !(i.id === id && (i.color || null) === color))
        : prev.map((i) => (i.id === id && (i.color || null) === color ? { ...i, qty } : i))
    );

  const clear = () => setItems([]);

  const value = useMemo(
    () => ({
      items,
      add,
      remove,
      setQty,
      clear,
      open,
      setOpen,
      subtotal: items.reduce((s, i) => s + i.price * i.qty, 0),
      count: items.reduce((s, i) => s + i.qty, 0),
    }),
    [items, open]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);

export const formatAUD = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(n);
